import { Component, h, Prop } from '@stencil/core';
import { htmlSanitizer } from './../../../utils/html-sanitizer';

@Component({
  tag: 'vs-content-bundle-text',
})
export class ContentBundleText {
  @Prop() publishDate: string;
  @Prop() headerStyle: string;
  @Prop() headerText: string;
  @Prop() bodyText: string;
  @Prop() headerId: string;
  @Prop() eyebrowText: string;

  renderText = () => {
    switch (this.headerStyle) {
      case 'h3':
        return <h3 class="vs-h3 vs-content-bundle-header" innerHTML={htmlSanitizer(this.headerText)} {...(this.headerId.length > 0 ? { id: this.headerId } : {})}></h3>;
      case 'h4':
        return <h4 class="vs-h3 vs-content-bundle-header" innerHTML={htmlSanitizer(this.headerText)} {...(this.headerId.length > 0 ? { id: this.headerId } : {})}></h4>;
      case 'blockquote':
        return (
          <blockquote class="vs-h3 vs-content-bundle-header" innerHTML={htmlSanitizer(this.headerText)} {...(this.headerId.length > 0 ? { id: this.headerId } : {})}>
            {this.bodyText.length > 0 && (
              <cite class="vs-text vs-content-bundle-body vs-d-block vs-pt-2" innerHTML={htmlSanitizer(this.bodyText)}></cite>
            )}
          </blockquote>
        );
      case 'strong':
        return <strong class="vs-h3 vs-content-bundle-header" innerHTML={htmlSanitizer(this.headerText)} {...(this.headerId.length > 0 ? { id: this.headerId } : {})}></strong>;
    }
  };

  render() {
    return (
      <div class="vs-content-bundle-text">
        <p class="vs-text vs-meta vs-content-bundle-date">{this.publishDate}</p>
        {this.eyebrowText.length > 0 ? <p class="vs-lead vs-mb-1" innerHTML={htmlSanitizer(this.eyebrowText)}></p> : ''}
        {this.headerText.length > 0 ? this.renderText() : ''}
        {this.bodyText.length > 0 && this.headerStyle !== 'blockquote' && (
          <div class="vs-text vs-content-bundle-body" innerHTML={htmlSanitizer(this.bodyText)}></div>
        )}
      </div>
    );
  }
}
